import { baseApiService } from '@qapline/api';
import { config } from 'config';

export const filesApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getAttachedFile: builder.query<Blob, { filePath: string }>({
            query: ({ filePath }) => ({
                url: config.api.endpoints.files,
                method: 'GET',
                params: { filePath },
                responseHandler: (response) => response.blob(),
            }),
        }),
    }),
});

export const { useLazyGetAttachedFileQuery } = filesApi;
